// Hard-coded feature flags for staged rollouts.
// Flip a flag to true to surface the related UI; defaults are conservative
// so anything in-progress stays hidden from end users until it's ready.
//
// Usage:
//   import { NEXT_FEATURES } from "../featureFlags";
//   if (NEXT_FEATURES) { ... }

export const NEXT_FEATURES = false;

// Switches a test can flip (an object, so a test sets a field rather than re-importing a constant).
export const featureFlags = {
  /** 3D tab: a "Coming soon" badge and panel, no model generation (owner, 2026-10-12). The viewer and on-demand
   * generation behind it stay intact: set false to bring them back. */
  threeDComingSoon: true,
};
